export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant03-de.64841bd0.png";